if (!customElements.get('gift-wrap-option')) {
  customElements.define('gift-wrap-option', class GiftWrapOption extends HTMLElement {
    constructor() {
      super();

      this.checkbox = this.querySelector('[data-gift-wrap-toggle]');
      this.select = this.querySelector('[data-gift-wrap-theme]');
      this.themeWrapper = this.querySelector('[data-gift-wrap-theme-wrapper]');
      this.form = document.getElementById(this.dataset.formId);
      this.cartNotification = document.querySelector('cart-notification');

      if (!this.form || !this.checkbox || !this.select) return;

      this.submitButton = this.form.querySelector('[type="submit"]');
      this.spinner = this.form.querySelector('.loading-overlay__spinner');

      this.checkbox.addEventListener('change', this.toggleThemeVisibility.bind(this));
      this.toggleThemeVisibility();

      if (this.submitButton) {
        this.submitButton.addEventListener('click', this.onSubmitClick.bind(this));
      }
    }

    toggleThemeVisibility() {
      if (this.themeWrapper) {
        this.themeWrapper.style.display = this.checkbox.checked ? '' : 'none';
      }
    }

    addToCart(id, quantity, properties, renderSections) {
      const payload = { id, quantity };
      if (properties) payload.properties = properties;
      if (renderSections) {
        payload.sections = this.cartNotification ? this.cartNotification.getSectionsToRender().map((section) => section.id) : [];
        payload.sections_url = window.location.pathname;
      }

      return fetch(window.routes.cart_add_url, {
        ...fetchConfig('json'),
        body: JSON.stringify(payload),
      }).then((response) => response.json());
    }

    onSubmitClick(evt) {
      if (!this.checkbox.checked) return;

      evt.preventDefault();
      if (this.submitButton.classList.contains('loading')) return;

      const idInput = this.form.querySelector('[name="id"]');
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const mainVariantId = idInput ? idInput.value : null;
      const quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      const giftWrapVariantId = this.select.value;

      if (!mainVariantId || !giftWrapVariantId) return;

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      if (this.spinner) this.spinner.classList.remove('hidden');

      // Add the gift wrap first: this store's cart shows the most recently added
      // item first, so adding the product last makes it appear above its gift wrap
      // line, keeping the two visually bundled together.
      this.addToCart(giftWrapVariantId, 1, { _Voor_product: this.dataset.productTitle || '' })
        .then((giftWrapResponse) => {
          if (giftWrapResponse.status) {
            throw new Error(giftWrapResponse.description);
          }
          return this.addToCart(mainVariantId, quantity, null, true);
        })
        .then((mainResponse) => {
          if (mainResponse.status) {
            throw new Error(mainResponse.description);
          }
          // Only refresh the cart count bubble here: the notification popup only has
          // room to show one product, and showing the gift wrap instead of the item
          // the customer actually picked would be confusing.
          const bubbleHtml = mainResponse.sections && mainResponse.sections['cart-icon-bubble'];
          const bubble = document.getElementById('cart-icon-bubble');
          if (bubbleHtml && bubble && this.cartNotification) {
            bubble.innerHTML = this.cartNotification.getSectionInnerHTML(bubbleHtml);
          }
        })
        .catch((error) => {
          console.error(error);
          const errorWrapper = this.form.querySelector('.product-form__error-message-wrapper');
          const errorMessage = errorWrapper ? errorWrapper.querySelector('.product-form__error-message') : null;
          if (errorWrapper && errorMessage) {
            errorMessage.textContent = error.message || window.cartStrings.error;
            errorWrapper.hidden = false;
          }
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          if (this.spinner) this.spinner.classList.add('hidden');
        });
    }
  });
}
